import { render, staticRenderFns } from "./InstitutionModal.vue?vue&type=template&id=73b09f43&"
import script from "./InstitutionModal.vue?vue&type=script&lang=ts&"
export * from "./InstitutionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports